import { Box, Button, Dialog, DialogProps, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import { CurrentEmployeeSlip } from "../CurrentDispatchLinesData";
import { BoxButtonsWrappingStyle, ButtonStyleAccept, ButtonStyleCancel, ButtonStyleRefuse, ButtonWrapperStyle, ContentStyle, HeaderStyle, MainWrapper, OrderInfoContentStyle, OrderInfoTitleStyle, OrderInstructionsStyle, PopupContainerStyle, TableCellEmpStyle, TableCellJobStyle, TableCellRegNStyle, TableHeadStyle, TableRowStyle, linesSlipTableStyle } from "./styled";

export interface ILinesSlipProps {
  data?: CurrentEmployeeSlip;
  open: boolean;
  hideButtons: boolean;
  handleSubmit: (acceptFlag: 0 | 1) => void;
  onClose: () => void;
  onBackdropClick: DialogProps["onClose"];
}

export const LineSlip: React.FC<ILinesSlipProps> = ({
  data,
  handleSubmit,
  onClose,
  onBackdropClick,
  open,
  hideButtons
}) => {
  return (
    <Dialog open={open} onClose={onBackdropClick}>
      <Box sx={MainWrapper}>
        <Paper elevation={4} square sx={HeaderStyle}>Your Lines Slip</Paper>
        <Box sx={PopupContainerStyle}>
          <Box sx={BoxButtonsWrappingStyle}>
            {hideButtons ?
              <>
                <Typography sx={{ fontWeight: 700 }}>
                  Phone 604-254-5252 to change your response to this order.
                </Typography>
                <Box sx={ButtonWrapperStyle}>
                  <Button sx={ButtonStyleCancel} variant="contained" size="medium" onClick={onClose}>Cancel</Button>
                </Box>
              </> :
              <>
                <Typography sx={{ fontWeight: 700 }}>Phone 604-254-5252 or </Typography>
                <Box sx={ButtonWrapperStyle}>
                  <Button sx={ButtonStyleAccept} variant="contained" size="medium" onClick={() => handleSubmit(1)}>Accept</Button>
                  <Button sx={ButtonStyleRefuse} variant="contained" size="medium" onClick={() => handleSubmit(0)}>Refuse</Button>
                  <Button sx={ButtonStyleCancel} variant="contained" size="medium" onClick={onClose}>Cancel</Button>
                </Box>
              </>
            }
          </Box>
          <Box sx={ContentStyle}>
            <Box sx={{ mb: 2 }}>
              <Table>
                <TableBody>
                  <TableRow sx={TableRowStyle}>
                    <TableCell sx={OrderInfoTitleStyle}><Typography>Order By:</Typography></TableCell>
                    <TableCell sx={OrderInfoContentStyle}>{data?.orderBy}</TableCell>
                  </TableRow>
                  <TableRow sx={TableRowStyle}>
                    <TableCell sx={OrderInfoTitleStyle}><Typography>Date:</Typography></TableCell>
                    <TableCell sx={OrderInfoContentStyle}>{data?.orderDate}</TableCell>
                  </TableRow>
                  <TableRow sx={TableRowStyle}>
                    <TableCell sx={OrderInfoTitleStyle}><Typography>Ship:</Typography></TableCell>
                    <TableCell sx={OrderInfoContentStyle}>{data?.vessel}</TableCell>
                  </TableRow>
                  <TableRow sx={TableRowStyle}>
                    <TableCell sx={OrderInfoTitleStyle}><Typography>Start:</Typography></TableCell>
                    <TableCell sx={OrderInfoContentStyle}>{data?.startTime}</TableCell>
                  </TableRow>
                  <TableRow sx={TableRowStyle}>
                    <TableCell sx={OrderInfoTitleStyle}><Typography>Pier:</Typography></TableCell>
                    <TableCell sx={OrderInfoContentStyle}>{data?.pier}</TableCell>
                  </TableRow>
                  <TableRow sx={TableRowStyle}>
                    <TableCell sx={OrderInfoTitleStyle}><Typography>Order Quantity:</Typography></TableCell>
                    <TableCell sx={OrderInfoContentStyle}>{data?.quantityOrdered}</TableCell>
                  </TableRow>
                  <TableRow sx={TableRowStyle}>
                    <TableCell sx={OrderInfoTitleStyle}><Typography>Gang:</Typography></TableCell>
                    <TableCell sx={OrderInfoContentStyle}>{data?.gangTypeDescription}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Table sx={linesSlipTableStyle}>
                <TableHead sx={TableHeadStyle}>
                  <TableRow>
                    <TableCell sx={TableCellJobStyle}><Typography sx={{ fontWeight: 700 }}>Job</Typography></TableCell>
                    <TableCell sx={TableCellEmpStyle}><Typography sx={{ fontWeight: 700 }}>Employee</Typography></TableCell>
                    <TableCell sx={TableCellRegNStyle}><Typography sx={{ fontWeight: 700 }}>Emp. #</Typography></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.employeesDispatched.map((emp, i) => (
                    <React.Fragment key={i}>
                      {
                        <TableRow sx={TableRowStyle}>
                          <TableCell sx={TableCellJobStyle}>
                            <Typography>{emp.isLeadHand ? 'Lead Hand' : ''}</Typography>
                          </TableCell>
                          <TableCell sx={TableCellEmpStyle}>
                            <Typography>{emp.name}</Typography>
                          </TableCell>
                          <TableCell sx={TableCellRegNStyle}>
                            <Typography>{emp.registrationNumber}</Typography>
                          </TableCell>
                        </TableRow>
                      }
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>

            </Box>
            <Typography sx={OrderInstructionsStyle}>
              {data?.orderInstructionsText}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Dialog >
  );
}
